// Light/dark theme: "system" follows the OS until the user picks one.
// public/index.html applies the same choice before the bundle loads, so keep
// THEME_KEY and the stored format (JSON string) in sync with it.
import Vue from 'vue';
import { readStorage, writeStorage } from './utils/storage';

export const THEME_KEY = 'oppscan.theme';
export const THEME_MODES = ['system', 'light', 'dark'];

const media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

function storedMode() {
  const mode = readStorage(THEME_KEY, 'system');
  return THEME_MODES.includes(mode) ? mode : 'system';
}

export const theme = Vue.observable({ mode: storedMode(), isDark: false });

function apply() {
  const isDark = theme.mode === 'dark' || (theme.mode === 'system' && !!media && media.matches);
  const root = document.documentElement;
  root.classList.toggle('dark', isDark);
  root.style.colorScheme = isDark ? 'dark' : 'light';
  // Set after the class so charts re-reading the CSS variables get the new values.
  theme.isDark = isDark;
}

export function setThemeMode(mode) {
  if (!THEME_MODES.includes(mode)) return;
  theme.mode = mode;
  writeStorage(THEME_KEY, mode);
  apply();
}

if (media) {
  const onChange = () => { if (theme.mode === 'system') apply(); };
  if (media.addEventListener) media.addEventListener('change', onChange);
  else if (media.addListener) media.addListener(onChange);
}

apply();
